import * as React from 'react';
import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';
import ChatItemText from 'kts-platform-frame/display/components/ChatPanel/chatItem/ChatItemText';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    
     public chatList: JSX.Element[] = [
        <ChatItemText key="0" text="聊天内容1" nickname="昵称" isSelf={false} timer={new Date().getTime()} />,
        <ChatItemText key="1" text="聊天内容1聊天内容1" nickname="昵称" isSelf={false} timer={new Date().getTime()} />,
        <ChatItemText key="2" text="聊天内容1聊天内容1聊天内容1聊天内容1聊天内容1聊天内容1聊天内容1聊天内容1聊天内容1聊天内容1聊天内容1聊天内容1" nickname="昵称" isSelf={false} timer={new Date().getTime()} />,
        <ChatItemText key="3" text="聊天内容1聊天内容1" nickname="昵称" isSelf={true} timer={new Date().getTime()} />,
        <ChatItemText key="4" text="聊天内容1聊天内容1聊天内容1聊天内容1聊天内容1聊天内容1聊天内容1聊天内容1聊天内容1聊天内容1" nickname="昵称" isSelf={true} timer={new Date().getTime()} />,
        <ChatItemText key="5" text="聊天内容1" nickname="昵称" isSelf={true} timer={new Date().getTime()} />,
    ];
}


// WEBPACK FOOTER //
// ./src/display/platform/InBox/Cooperation/Modules.State.tsx